let hasMultipleProperties = false;

let changingCharts = false;

let earliest = 0;
let currentChart = '';
let currentKeyword = '';
let currentPeriodType = '';


let colorStops = {
    'basic': [
        [0, '#19CEDB'],
        [1, '#16A7E8']
    ],
    'pos': [
        [0, '#8FDDFF'],
        [1, '#44FB56']
    ],
    'neu': [
        [0, '#FFA200'],
        [1, '#FFDD00']
    ],
    'neg': [
        [0, '#F63BBE'],
        [1, '#FB4444']
    ],
    'fem': [
        [0, '#FF3782'],
        [1, '#FF37CA']
    ],
    'mal': [
        [0, '#19CEDB'],
        [1, '#16A7E8']
    ],
    'ukn': [
        [0, '#2BEDF3'],
        [1, '#16E88D']
    ],
    'percent': [
        [0, '#19CEDB'],
        [1, '#16A7E8']
    ]
};


let tooltipIdentifiers = {

    'pos': 'Positiv',
    'neu': 'Neutral',
    'neg': 'Negativ',
    'fem': 'Frau',
    'mal': 'Mann',
    'ukn': 'Unbekannt'

};


let platformIdentifiers = {
    'tripadvisor': 'TripAdvisor',
    'facebook': 'Facebook',
    'google': 'Google'
};


let guestsIdentifiers = {

    'unknown': 'Unbekannt',
    'woman': 'Frauen',
    'man': 'Männer',
    'other': 'Andere'

};
export let chartHeight = window.innerHeight * 0.43;
export let chartMarginBottom = window.innerWidth * 0.025;
export let plotLineColor = 'rgba(185,185,219,0.25)';


let chart = {
    'config': null,
    'element': null,
    'data': []
};




export let ageIdentifiers = {

    '13-17': '13 - 17',
    '18-24': '18 - 24',
    '25-34': '25 - 34',
    '35-49': '35 - 49',
    '50-64': '50 - 64',
    '65+': '65+'

};